import React, { useState, useEffect } from "react";
import SideNavBar from "./SideNavBar";
import { useProSidebar } from 'react-pro-sidebar';
import NavBarMain from './NavBarMain';
import Table from "react-bootstrap/Table";
import axios from ".././axios-interceptor";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { base_url, ACTION_TYPE_APPROVED, SERVICE_REQUEST_NEW_LOAN, LOAN_CURRENCY_TYPE_USD, ACTION_TYPE_PAYMENT_TO_BUSINESS, LOAN_CURRENCY_TYPE_BHD, SERVICE_REQUEST_EXTEND_TENURE, SERVICE_REQUEST_PRE_CLOSURE, ACTION_TYPE_BUSINESS_CREATION, ACTION_TYPE_KYC_DOCUMENTS, ACTION_TYPE_SERVICE_REQUEST, ACTION_TYPE_LOAN_REPAYMENT, SERVICE_REQUEST_PARTIAL_PRE_PAYMENT } from "../utilities";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';


const History = (props) => {
  const navigate = useNavigate();
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
 }, []);

  const [businessHistory, setBusinessHistory] = useState([])
  const [loading, setLoading] = useState(true);
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  let ltwo = props.loading;


  useEffect(() => {
    axios
      .post(base_url + "business-master/get_business_history_tab", {
        "business_id": Cookies.get("business_id")
      })
      .then((res) => {
        setBusinessHistory(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Business");
          Cookies.remove("User_Refreshtoken_Business");
          navigate("/");
        }
      });
  }, []);

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...businessHistory].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setBusinessHistory(sortedData);
  };

  const columns = [
    { title: "Date", field: "date" },
    { title: "Actions", field: "action_type" },
    { title: "By Whom", field: "by_whom" },
    // {title:"Last Activity", field:"document_type"}
  ];
  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <SideNavBar />
      <main style={{ width: "100%" }}>
        <NavBarMain />

        {loading ? <div className="historyLoader">
                      <ThreeDots
                        height="70"
                        width="70"
                        radius="9"
                        color="#3D79F3"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />
                    </div>
                    : !loading && businessHistory.length !== 0 ?
          <div className={`ps-4 pe-4 mt-2 `}>
            <div className="d-flex justify-content-between mb-2">
              <div className=" d-flex gap-4 align-items-center ">
                <h1 className="">History</h1>
              </div>
            </div>

            <div className="busns_histry_table_main">
              <Table striped className="busns_histry_table  " >
                <thead>
                  <tr>
                    {columns.map((header, id) => {
                      return (
                        <th
                          className={`Cpointer ${header.title === 'Date' ? 'text-center' : ''}`}

                          key={header.field}
                          onClick={() => handleSort(header.field)}
                        >
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} style={{}} />
                          ) :
                            <>

                              {header.title}
                              &#9662;
                            </>
                          }
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody className="">
                  {businessHistory.map((data, index) => {
                    let type = data.action_type;
                    return (
                      <tr key={index}>
                        <td className="text-center"> {ltwo || loading ? (
                          <Skeleton width={100} height={15} />
                        ) : data.date == null ? '-' : <div className="bus_hist_date">{moment(data.date).format('DD MMM YYYY')}</div>}</td>
                        <td > {ltwo || loading ? (
                          <Skeleton width={100} height={15} />
                        ) : type === undefined || type == '' ? '-' : <div className="bus_hist_actions">{
                          type === ACTION_TYPE_SERVICE_REQUEST && data.service_type_code === SERVICE_REQUEST_NEW_LOAN ? data.loan_reference_number !== undefined ? <div>New Loan Request Raised Ref No <b>{data.loan_reference_number}</b></div> : 'New Loan Request Raised'
                            : type === ACTION_TYPE_SERVICE_REQUEST && data.service_type_code === SERVICE_REQUEST_EXTEND_TENURE ? <div>Extend tenure request raised ref no <b>{data.loan_reference_number}</b></div>
                              : type === ACTION_TYPE_SERVICE_REQUEST && data.service_type_code === SERVICE_REQUEST_PRE_CLOSURE ? <div>Preclosure request raised ref no <b> {data.loan_reference_number}</b></div>
                              : type === ACTION_TYPE_SERVICE_REQUEST && data.service_type_code === SERVICE_REQUEST_PARTIAL_PRE_PAYMENT ? <div>Partial pre-payment request raised ref no <b>{data.loan_reference_number}</b></div>
                                : type === ACTION_TYPE_APPROVED && data.service_type_code === SERVICE_REQUEST_NEW_LOAN ? <div>Business approved terms and conditions ref no <b>{data.loan_reference_number}</b></div>
                                  : type === ACTION_TYPE_APPROVED && data.service_type_code === SERVICE_REQUEST_EXTEND_TENURE ? <div>Extend tenure approved ref no <b>{data.loan_reference_number}</b></div>
                                    : type === ACTION_TYPE_APPROVED && data.service_type_code === SERVICE_REQUEST_PRE_CLOSURE ? <div>Preclosure approved ref no <b>{data.loan_reference_number}</b></div>
                                    : type === ACTION_TYPE_APPROVED && data.service_type_code === SERVICE_REQUEST_PARTIAL_PRE_PAYMENT ? <div>Partial pre-payment approved ref no <b>{data.loan_reference_number}</b></div>
                                      : type === ACTION_TYPE_PAYMENT_TO_BUSINESS && data.paid_currency === LOAN_CURRENCY_TYPE_USD ? <div className=''>
                                        Amount Received <b>{"$" + " " + Number(data.paid_amount).toLocaleString()}</b>
                                        {" "}Received Via:   <b>{data.received_via}</b>
                                        {", "}Ref No {" "}
                                        <b>{data.transaction_reference_no}</b>
                                      </div> : type === ACTION_TYPE_PAYMENT_TO_BUSINESS && data.paid_currency === LOAN_CURRENCY_TYPE_BHD ? <div className=''>
                                        Amount Received <b>{"BHD" + " " + Number(data.paid_amount).toLocaleString()}</b>
                                        {" "}Received Via:   <b>{data.received_via}</b>
                                        {", "}Ref No{" "}
                                        <b>{data.transaction_reference_no}</b>
                                      </div>
                                        : type === ACTION_TYPE_BUSINESS_CREATION ? "Business Created"
                                          : type === ACTION_TYPE_KYC_DOCUMENTS ? data.document_type + " uploaded"

                                            : type === ACTION_TYPE_LOAN_REPAYMENT && data.paid_currency === LOAN_CURRENCY_TYPE_USD ? <div className=''>
                                              Loan Repayment <b>{"$" + " " + Number(data.paid_amount).toLocaleString()}</b>
                                              {" "}Paid Via:   <b>{data.paid_via}</b>
                                              {", "}Ref No {" "}
                                              <b>{data.transaction_reference_no}</b>
                                            </div> : type === ACTION_TYPE_LOAN_REPAYMENT && data.paid_currency === LOAN_CURRENCY_TYPE_BHD ? <div className=''>
                                              Loan Repayment <b>{"BHD" + " " + Number(data.paid_amount).toLocaleString()}</b>
                                              {" "}Paid Via:   <b>{data.paid_via}</b>
                                              {", "}Ref No {" "}
                                              <b>{data.transaction_reference_no}</b>
                                            </div> : ''
                        }</div>}</td>
                        <td > {ltwo || loading ? (
                          <Skeleton width={100} height={15} />
                        ) : ((data.by_whom === undefined) && (data.action_type === ACTION_TYPE_SERVICE_REQUEST )) ? Cookies.get("user_name") 
                           : (data.action_type === ACTION_TYPE_APPROVED && data.service_type_code === SERVICE_REQUEST_NEW_LOAN) ? Cookies.get("user_name") 
                           : ((data.action_type === ACTION_TYPE_APPROVED) && (data.service_type_code === SERVICE_REQUEST_EXTEND_TENURE || data.service_type_code === SERVICE_REQUEST_PRE_CLOSURE || data.service_type_code === SERVICE_REQUEST_PARTIAL_PRE_PAYMENT)) ? <div className="bus_hist_date">{data.by_whom}</div> 
                            : <div className="bus_hist_date">{data.by_whom}</div>
                      }</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>

          </div>
          : <div className="text-center fw-bold fs-4 text-secondary no_histry_txt">No history to display</div>}
      </main>
    </div>


  );
}

export default History;
